import { CommonExtension } from '../../../core/index.js';
import { liftListItem, sinkListItem } from 'prosemirror-schema-list';
import 'prosemirror-inputrules';
import { PluginKey } from 'prosemirror-state';
import 'prosemirror-model';
import 'prosemirror-commands';

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var isShouldIndent = function(selection) {
    var parentNode = findParentNode(function(item) {
        return item.type && (item.type.name === "table" || item.type.name === "list_item" || item.type.name === "task_item");
    })(selection);
    if (parentNode) {
        if (parentNode.node.type.name === "table") {
            return false;
        }
    }
    return true;
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var IndentType;
(function(IndentType) {
    IndentType[IndentType["Less"] = -1] = "Less";
    IndentType[IndentType["More"] = 1] = "More";
})(IndentType || (IndentType = {}));
var setIndent = function(indentType) {
    return function(state, dispatch, view) {
        var attrsGetter = function(attrs) {
            return _objectSpreadProps(_objectSpread({}, attrs), {
                indent: attrs.indent + indentType
            });
        };
        var selection = state.selection, tr = state.tr, schema = state.schema;
        var _schema_nodes = schema.nodes, listItem = _schema_nodes.list_item, taskListItem = _schema_nodes.task_item, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list;
        var itemTypes = [
            listItem,
            taskListItem
        ];
        var listTypes = [
            ordered_list,
            bullet_list,
            task_list
        ];
        var transaction;
        var predicate = function(node) {
            return listTypes.includes(node.type);
        };
        var parentList = findParentNode(predicate)(selection);
        selection.ranges.forEach(function(range) {
            var from = range.$from.pos;
            var to = range.$to.pos;
            var blockStart = 0;
            var blockEnd = 0;
            tr.doc.nodesBetween(from, to, function(node, pos) {
                if (pos > blockStart && pos < blockEnd) return;
                if (itemTypes.includes(node.type)) {
                    if (pos < from || pos > to) return;
                    blockStart = pos;
                    blockEnd = pos + node.nodeSize;
                }
                if (parentList) {
                    var listNode = parentList.node;
                    if (listNode !== node) return;
                }
                var attrs = node.attrs;
                if (attrs.indent !== undefined && (indentType !== IndentType.Less || attrs.indent > 0)) {
                    var newAttrs = attrsGetter(attrs);
                    transaction = tr.setNodeMarkup(pos, null, newAttrs);
                }
            });
        });
        if (!transaction) return false;
        if (dispatch) {
            dispatch(transaction);
        }
        return true;
    };
};

var indentLess = function() {
    return function(state, dispatch, view) {
        var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, list_item = _state_schema_nodes.list_item, task_item = _state_schema_nodes.task_item, selection = state.selection;
        if (setIndent(IndentType.Less)(state, dispatch, view)) {
            return true;
        }
        if (liftListItem(list_item)(state, dispatch) || liftListItem(task_item)(state, dispatch)) {
            return true;
        }
        if (isShouldIndent(selection)) {
            return true;
        }
        return false;
    };
};

var indentMore = function() {
    return function(state, dispatch, view) {
        var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, list_item = _state_schema_nodes.list_item, task_item = _state_schema_nodes.task_item, selection = state.selection;
        if (sinkListItem(list_item)(state, dispatch) || sinkListItem(task_item)(state, dispatch)) {
            return true;
        }
        if (isShouldIndent(selection)) {
            return setIndent(IndentType.More)(state, dispatch, view);
        }
        return false;
    };
};

var handleBackspace = function() {
    return function(state, dispatch, view) {
        var sel = state.selection;
        // 单光标状态，在文本的最前面
        if (sel.from === sel.to && !sel.$anchor.nodeBefore && sel.$anchor.parent.attrs.indent > 0) {
            return indentLess()(state, dispatch, view);
        }
        return false;
    };
};

var isIndentLessDisabled = function() {
    return function(state, dispatch, view) {
        var schema = state.schema, selection = state.selection;
        var _schema_nodes = schema.nodes, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list, table = _schema_nodes.table;
        var listTypes = [
            ordered_list,
            bullet_list,
            task_list
        ];
        var predicate = function(node) {
            return listTypes.includes(node.type);
        };
        var predicateTable = function(node) {
            return node.type === table;
        };
        var listInfo = findParentNode(predicate)(selection);
        var tableInfo = findParentNode(predicateTable)(selection);
        if (listInfo && tableInfo) {
            // 同时存在list和table
            var listPos = listInfo.pos;
            var tablePos = tableInfo.pos;
            if (listPos > tablePos) {
                // 在列表中，不禁用缩进
                return false;
            }
            // 在表格中，禁用缩进
            return true;
        }
        if (listInfo) {
            // 在列表中，不禁用缩进
            return false;
        }
        if (tableInfo) {
            // 在表格中，禁用缩进
            return true;
        }
        return !setIndent(IndentType.Less)(state);
    };
};

var isIndentMoreDisabled = function() {
    return function(state, dispatch, view) {
        var schema = state.schema, selection = state.selection;
        var _schema_nodes = schema.nodes, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list, table = _schema_nodes.table;
        var listTypes = [
            ordered_list,
            bullet_list,
            task_list
        ];
        var predicate = function(node) {
            return listTypes.includes(node.type);
        };
        var predicateTable = function(node) {
            return node.type === table;
        };
        var listInfo = findParentNode(predicate)(selection);
        var tableInfo = findParentNode(predicateTable)(selection);
        if (listInfo && tableInfo) {
            // 同时存在list和table
            var listPos = listInfo.pos;
            var tablePos = tableInfo.pos;
            if (listPos > tablePos) {
                // 在列表中，不禁用缩进
                return false;
            }
            // 在表格中，禁用缩进
            return true;
        }
        if (listInfo) {
            // 在列表中，不禁用缩进
            return false;
        }
        if (tableInfo) {
            // 在表格中，禁用缩进
            return true;
        }
        return !setIndent(IndentType.More)(state);
    };
};

var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var IndentExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(IndentExtension, CommonExtension);
    var _super = _createSuper(IndentExtension);
    function IndentExtension() {
        _classCallCheck(this, IndentExtension);
        return _super.apply(this, arguments);
    }
    var _proto = IndentExtension.prototype;
    _proto.commands = function commands() {
        return {
            indentLess: indentLess,
            indentMore: indentMore,
            isIndentMoreDisabled: isIndentMoreDisabled,
            isIndentLessDisabled: isIndentLessDisabled
        };
    };
    _proto.keys = function keys() {
        return {
            Tab: convertCommand(indentMore()),
            "Shift-Tab": convertCommand(indentLess()),
            Backspace: convertCommand(handleBackspace())
        };
    };
    _createClass(IndentExtension, [
        {
            key: "name",
            get: function get() {
                return "indent";
            }
        }
    ]);
    return IndentExtension;
}(CommonExtension);

export { IndentExtension };
//# sourceMappingURL=index.js.map
